import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warn\"><defs><style type=\"text/css\"></style></defs><path d=\"M510.65 962C264.6 962 63.3 760.26 63.3 513.7S264.6 65.41 510.65 65.41 958 267.14 958 513.7 756.69 962 510.65 962zM655 857.61a377.28 377.28 0 0 0 198.65-199.12 371.82 371.82 0 0 0 0-289.58A377.18 377.18 0 0 0 655 169.79a369.15 369.15 0 0 0-288.64 0 377.09 377.09 0 0 0-198.71 199.12 371.82 371.82 0 0 0 0 289.58A377.12 377.12 0 0 0 366.33 857.6a369.21 369.21 0 0 0 288.64 0z\" fill=\"#949DA6\" p-id=\"8421\" /><path d=\"M474 662m0-37.5l0-338q0-37.5 37.5-37.5l0 0q37.5 0 37.5 37.5l0 338q0 37.5-37.5 37.5l0 0q-37.5 0-37.5-37.5Z\" fill=\"#949DA6\" p-id=\"8422\" /><path d=\"M514.5 741.5m-37.5 0a37.5 37.5 0 1 0 75 0 37.5 37.5 0 1 0-75 0Z\" fill=\"#949DA6\" p-id=\"8423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toast/warn.svg
// module id = x2VQ
// module chunks = 55